import { Flex, Skeleton, StackProps } from "@chakra-ui/react";
import CDS from "design-system";
import ProfileAvatar from "components/ProfileAvatar";
import { Heading16 } from "components/Heading";
import { NewHireJourney } from "models/v2/newHireJourney";
import { dateToAbbrevMonthYear } from "helpers/time";

interface NewHireProfileCardProps extends StackProps {
  newHireJourney: NewHireJourney | undefined;
  includeLink?: boolean;
}

export default function NewHireProfileCard({ newHireJourney, includeLink = false, ...rest }: NewHireProfileCardProps) {
  const newHire = newHireJourney?.newHire;

  if (!newHireJourney) {
    return (
      <Flex gap="3" align="center" {...rest}>
        <Skeleton w="40px" h="40px" borderRadius="full" />
        <Flex direction="column" gap="1">
          <Skeleton height="18px" width="200px" />
          <Skeleton height="14px" width="300px" />
        </Flex>
      </Flex>
    );
  }

  const subtitle = [newHire?.title, dateToAbbrevMonthYear(newHireJourney.startDate), newHire?.location]
    .filter(Boolean)
    .join(" · ");

  return (
    <Flex gap="3" align="center" {...rest}>
      <ProfileAvatar size="sm" user={newHire} />
      <Flex direction="column">
        <Heading16>{newHire?.fullName}</Heading16>
        {subtitle && (
          <CDS.Text14 fontSize="13px" color="content.tertiary">
            {subtitle}
          </CDS.Text14>
        )}
      </Flex>
    </Flex>
  );
}
